import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieFactorySummary implements MutableValue {
  public isNew = true;

  private fDueDate?: Date;
  private fMainArtworkStorageItemId?: string;

  public constructor(
    private fId: string,
    private fProduct: string,
    private fQuantity: number,
    private fStoreItemId: string,
    private fStatus: string,
    private fStore: string,
    private fDelay: number,
    private fUpgrades: string[],
    private fPriority: number
  ) {
    [
      fId,
      fProduct,
      fQuantity,
      fStoreItemId,
      fStatus,
      fStore,
      fDelay,
      fUpgrades,
      fPriority,
    ].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get product() {
    return this.fProduct;
  }

  get quantity() {
    return this.fQuantity;
  }

  get storeItemId() {
    return this.fStoreItemId;
  }

  get status() {
    return this.fStatus;
  }

  get store() {
    return this.fStore;
  }

  get dueDate() {
    return this.fDueDate;
  }

  get mainArtworkStorageItemId() {
    return this.fMainArtworkStorageItemId;
  }

  get delay() {
    return this.fDelay;
  }

  get upgrades() {
    return this.fUpgrades;
  }

  get priority() {
    return this.fPriority;
  }
}
